// extracted by mini-css-extract-plugin
export var input = "styles-module--input--WEXqx";
export var text = "styles-module--text--PwhEB";
export var search = "styles-module--search--7hki3";
export var primary = "styles-module--primary--tP7+y";
export var secondary = "styles-module--secondary--+WLos";
export var invalid = "styles-module--invalid--WxPXO";
export var disabled = "styles-module--disabled--uoIvy";